export default __webpack_public_path__ + "static/media/dd.174e20c6.mp3";